import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d6bedfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "part-com" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "part-name" }, "党建工作"),
  /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, "Labor RIghts Protection")
], -1))
const _hoisted_3 = { class: "nav-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "new-list" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-des" }, "江门市政府网站江门市政府网站江门市政府网站江门市政府网 站江门市政府网站江门市政府网站..", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time" }, "2022-08-17", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { ref, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'newTypeCom',
  setup(__props) {

let currentNav: number = ref(0);
let changeNav = (index: number) => {
  currentNav.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab-item", _unref(currentNav)==index?'active-item':'']),
          onClick: ($event: any) => (_unref(changeNav)(index)),
          key: index
        }, "二级标题", 10, _hoisted_4)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
        return _createElementVNode("div", {
          class: "news-item",
          key: index
        }, _hoisted_8)
      }), 64))
    ])
  ]))
}
}

})